import { type PropsWithChildren, forwardRef } from "react";

/** Two equal columns on desktop, stacked on mobile. Includes an empty trailing cell for half-width layouts. */
export const DoubleColumnContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="gap-x-6 lg:grid lg:grid-cols-2">
      {children}
      <div />
    </div>
  );
};

interface FormContainerProps extends PropsWithChildren, React.FormHTMLAttributes<HTMLFormElement> {
  onSubmit: React.FormEventHandler<HTMLFormElement> | undefined;
}

export const FormContainer = forwardRef<HTMLFormElement, FormContainerProps>(function FormContainer(
  { onSubmit, children, ...props },
  ref,
) {
  return (
    <form ref={ref ?? null} onSubmit={onSubmit} className="flex w-full flex-col gap-6" {...props}>
      {children}
    </form>
  );
});
